import {
	Directive,
	ElementRef,
	HostListener,
	Input,
	Renderer2,
} from '@angular/core';

@Directive({
	selector: '[appHoverPreview]',
})
export class HoverPreviewDirective {
  @Input('appHoverPreview') previewText = '';

  private previewBox: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
  	if (!this.previewText) {return;}

  	const rect = this.el.nativeElement.getBoundingClientRect();
  	const box = this.renderer.createElement('div');
  	box.innerText = this.previewText;
  	this.renderer.addClass(box, 'hover-preview-box');
  	this.renderer.setStyle(box, 'top', `${rect.bottom + window.scrollY}px`);
  	this.renderer.setStyle(box, 'left', `${rect.left + window.scrollX}px`);
  	document.body.appendChild(box);
  	this.previewBox = box;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
  	if (this.previewBox) {
	  document.body.removeChild(this.previewBox);
	  this.previewBox = null;
  	}
  }
}
